/* Данните, вградени в страницата при генерирането ѝ.

   scripts/prerender.mjs пише за всяка страница нейните данни в
   <script type="application/json" id="…">: продукта (sa-product), продуктите
   на категорията (sa-category) или всички продукти (sa-products). React ги
   ползва веднага, вместо да чака Firestore.

   Защо: докато Firestore не отговори, страницата на продукта беше празна
   обвивка — заглавие „Stamsy Art“, празно h1, цена 0.00 €. Google изпълнява
   JavaScript и индексира това, което вижда след него; ако не дочака
   потоковата връзка на Firestore, всички продукти изглеждаха еднакви и Search
   Console ги отчиташе като копия („Duplicate, Google chose different
   canonical than user“). Firestore продължава да се пита както досега и
   обновява данните, щом отговори. */

export function readEmbedded(id) {
  if (typeof document === 'undefined') return null;
  const el = document.getElementById(id);
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}
